import { useCallback, useEffect, useRef, useState } from 'react'
import { track } from '../Utils/analytics'

const DONE_MS = 2000

/* Tapping the selected chip/tab or Početna (spec 6): scrolled down → glide to
   the top; already at the top → refresh, with "Osvježavam vijesti…" under the
   chips and "Sve je ažurirano…" when nothing new came. method: how analytics
   names it (chip_tap, tab_tap). */
export default function useTapToRefresh(feed, method = 'tab_tap') {
  const [row, setRow] = useState(null) // null | 'loading' | 'done'
  const timer = useRef(null)
  const refresh = feed.refresh
  const eventProps = feed.eventProps

  const run = useCallback(
    async (how = method) => {
      clearTimeout(timer.current)
      setRow('loading')
      track('feed_refresh', { surface: eventProps?.().surface ?? null, method: how })
      const { newCount, error } = await refresh({ markNew: true })
      if (!error && newCount === 0) {
        setRow('done')
        timer.current = setTimeout(() => setRow(null), DONE_MS)
      } else {
        setRow(null)
      }
    },
    [refresh, eventProps, method]
  )

  const tap = useCallback(() => {
    if (window.scrollY > 4) window.scrollTo({ top: 0, behavior: 'smooth' })
    else run()
  }, [run])

  useEffect(() => () => clearTimeout(timer.current), [])
  return { row, tap, run }
}
